import React, { useState } from "react";
import { useGetFhirPatientsQuery, useUpdateFhirPatientMutation } from "../../redux/service/fhir_service";
import { toast } from "react-toastify";
import { PiNotePencilFill } from "react-icons/pi";
import { TiInfo } from "react-icons/ti";
import FhirEditDialog from "./FhirEditDialog";

function FHIR() {
  const { data, isLoading: dataLoading, error, refetch } = useGetFhirPatientsQuery();
  const [updateFhirPatient, { isLoading: saveLoading }] = useUpdateFhirPatientMutation();
  const [isEditing, setIsEditing] = useState({show: false, record: null});

  // Cancel handler
  const handleCancel = () => {
    setIsEditing({show: false, record: null});
  };

  // Save handler
  const handleSave = async (payload) => {
    console.log(payload, "payload");
    try {
      const finalData = {
        //pid: getLoggedinUser()?.pid,
        client_id: payload?.client_id,
        username: payload?.username,
        id: isEditing.record?.id,
        redirect_uris: payload.records.map((item) => item.redirect_uris),
      }

      await updateFhirPatient(finalData);
      toast.success("FHIR record updated successfully");
      
      // Refresh data and close dialog
      await refetch();
      setIsEditing({show: false, record: null});
    } catch (error) {
      console.error("Error saving record:", error);
      toast.error("Failed to save FHIR record");
    }
  };

  // Loading state
  if (dataLoading) {
    return (
      <div className="p-5 bg-white">
        <div className="flex justify-center items-center h-64">
          <div className="text-lg">Loading FHIR data...</div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="p-5 bg-white">
        <div className="text-red-600 text-center">
          Error loading FHIR data: {error.message}
        </div>
      </div>
    );
  }

  // Empty state
  if (!data?.data || data.data.length === 0) {
    return (
      <div className="p-5 bg-white">
        <div className="text-center text-gray-500">No FHIR records found</div>
      </div>
    );
  }

  return (
    <div className="p-5 bg-white">
      {/* Edit Dialog */}
      {isEditing.show && (
      <FhirEditDialog
        isOpen={isEditing.show}
        onClose={handleCancel}
        isLoading={saveLoading}
        onSave={handleSave}
        recordId={isEditing.record?.id}
        selectedRecord={isEditing.record}
      />
      )}

      {/* Page Header */}
      <div className="flex justify-between mb-4 border-b border-gray-300 pb-2">
        <h4 className="text-lg font-semibold">FHIR Configuration</h4>
      </div>

      {/* Read-only Display Card */}
      <div className="border rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex justify-between items-center mb-3 pb-3 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <TiInfo color="blue" size={20} />
            <h3 className="text-base font-semibold text-gray-700">FHIR Configuration</h3>
          </div>
          <button
            type="button"
            title="Edit Configuration"
            onClick={(e) => {
              e.preventDefault();
              setIsEditing({show: true, record: data?.data[0]});
            }}
            className="flex items-center gap-2 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition"
            disabled={saveLoading}
          >
            <PiNotePencilFill size={18} />
            <span className="text-sm font-medium">Edit</span>
          </button>
        </div>

        {/* Display FHIR URIs */}
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-600 mb-2">FHIR URIs:</h4>
          <div className="space-y-2">
            {data?.data[0]?.redirect_uris?.map((uri, index) => (
              <div key={index} className="flex items-center gap-2 bg-gray-50 p-3 rounded border border-gray-200">
                <span className="text-xs text-gray-500 font-mono bg-gray-200 px-2 py-1 rounded">#{index + 1}</span>
                <span className="text-sm text-gray-700 flex-1 break-all">{uri}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Display Client ID and Username */}
        <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-200">
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Client ID</label>
            <p className="text-sm text-gray-700 mt-1 font-mono bg-gray-50 p-2 rounded">{data?.data[0]?.client_id || 'N/A'}</p>
          </div>
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Username</label>
            <p className="text-sm text-gray-700 mt-1 bg-gray-50 p-2 rounded">{data?.data[0]?.username || 'N/A'}</p>
          </div>
        </div>

        <div className="mt-3 p-2 bg-blue-50 border border-blue-200 rounded">
          <p className="text-xs text-blue-600">
            <strong>Note:</strong> Client Secret and Password are same as Patient Portal credentials
          </p>
        </div>
      </div>
    </div>
  );
}

export default FHIR;
